
<div
  class="lobby-table-game-specific-wrapper lobbyTableGameSpecificWrapper--3fAEk desktop--1Txr1"
  data-role="lobby-table-game-specific-wrapper"
>
  <ol class="RecentResultsBar--3aBzj mt-0 mb-0" data-role="recent-results">
    <li
      v-for="(resultat, index) in tableauResultat"
      :key="index"
      :class="['result--3aa_E', getClass(resultat)]"
      data-role="recent-result"
    >
      {{ getTotalResultat(resultat) }}
    </li>
  </ol>
</div>
